module.exports = __webpack_public_path__ + "static/img/xi_112.1cdd7b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_112.jpg
// module id = jqhs
// module chunks = 1